import { render } from "./subComponentLabels.vue?vue&type=template&id=ec96a0e2&scoped=true"
import script from "./subComponentLabels.vue?vue&type=script&lang=js"
export * from "./subComponentLabels.vue?vue&type=script&lang=js"

import "./subComponentLabels.vue?vue&type=style&index=0&id=ec96a0e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec96a0e2"]])

export default __exports__